import axios from 'axios';

export default {
  index(query: any = null, is_paginate = true) {
    return new Promise((resolve, reject) => {
      // let params = {page: currentPage, pagination: is_paginate}
      // params = {...query, ...params};
      axios.get('departments', {
        params: query
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      }).finally(() => {
        //
      });
    })
  },
  store(payload: any) {
    return axios.post('departments', payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  show(id: any) {
    return axios.get('departments/' + id)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  update(id:any, payload: any) {
    return axios.put('departments/' + id, payload)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  },
  destroy(id: any) {
    return axios.delete('departments/' + id)
      .then(response => {
        return response.data;
      }).catch(error => {
        throw(error.response);
      });
  }
}
